import { createModal } from '@/components/create-modal';
import { RecommendedGuidePanel } from './components/recommend-panel';
import { h, render } from 'preact';
import { IGame, IRecommendationButton } from './types';

export type RecommendModalOnCloseParams = {
  type: 'dismiss' | 'quit' | 'navigate' | 'back';
  data?: {
    game: IGame;
  };
};
export const createRecommendModal = (params: {
  games: IGame[];
  title: string;
  buttons: IRecommendationButton[];
  onClose?: (params: RecommendModalOnCloseParams) => void;
  onOpen?: () => void;
}) => {
  const modal = createModal({
    title: params.title,
    content: (
      <RecommendedGuidePanel
        games={params.games}
        title={params.title}
        buttons={params.buttons}
        onClose={params.onClose}
      />
    ),
    backdropColor: '#1a1a1a',
    placement: 'bottom',
    noHeader: true,
    padding: '0px',
    height: '450px',
    onClose: () => {
      params.onClose?.({
        type: 'back'
      });
    },
    onOpen: params.onOpen
  });

  modal.show();

  return modal;
};

export type { IGame, IRecommendationButton };
